/**
 * @generated SignedSource<<77d4deaceb638cef79aa4ae6ad556f36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PastUpdatesQuery$variables = {
  first: number;
};
export type PastUpdatesQueryVariables = PastUpdatesQuery$variables;
export type PastUpdatesQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly entityId: string;
      readonly " $fragmentSpreads": FragmentRefs<"PastUpdatesList_user">;
    };
  } | null;
};
export type PastUpdatesQueryResponse = PastUpdatesQuery$data;
export type PastUpdatesQuery = {
  variables: PastUpdatesQueryVariables;
  response: PastUpdatesQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PastUpdatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "args": (v2/*: any*/),
                "kind": "FragmentSpread",
                "name": "PastUpdatesList_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PastUpdatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "UserCheckinsConnection",
                "kind": "LinkedField",
                "name": "checkins",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserCheckinsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Checkin",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "weekId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a07eb4646eb77119b93e9cecd081b09d",
    "id": null,
    "metadata": {},
    "name": "PastUpdatesQuery",
    "operationKind": "query",
    "text": "query PastUpdatesQuery(\n  $first: Int!\n) {\n  viewer {\n    user {\n      entityId\n      ...PastUpdatesList_user_3ASum4\n      id\n    }\n    id\n  }\n}\n\nfragment PastUpdatesList_user_3ASum4 on User {\n  checkins(first: $first) {\n    pageInfo {\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        weekId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9898d8c41dd5fdea25d4df97cc4378b0";

export default node;
